











import Vue from 'vue';
import QuickLink from './quicklinksection/QuickLink.vue';
import { IQuickLink, IQuickLinkSection } from '../../../common/interfaces/frontpage.interface';
import TIcons from '../../../types/TIcons';

export default Vue.extend({
  name: `QuickLinkSection`,
  components: { QuickLink },
  data(): IQuickLinkSection {
    return {
      iconList: Object.values(TIcons.frontpage.quickLinks),
    };
  },
  props: {
    quickLinks: {
      required: true,
      type: Array as () => IQuickLink[],
    },
  },
});
